<template>
  <Coverages lob :coverages="coverageInfo" />
</template>

<style scoped>
</style>

<script>
import apiService from '@/services/shared/agentPortalApiService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';
import Coverages from '@/components/Shared/Coverages.vue';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'LineOfBusinessCoverages',
  components: { Coverages },
  data: function () {
    return {
      loading: true,
      coverageInfo: null
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getLineOfBusinessCoverages(this.clientId, this.policyOrderNumber, this.lobCode);
    if (rs.code === 0) {
      if (rs.data.length === 0) this.coverageInfo = {};
      this.coverageInfo = coverageTranslator.translateLineOfBusinessCoverages(rs.data[0]);
    } else {
      this.error = true;
      this.setError(rs.message);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
